/** Select value representing the default / fallback locale in the Messages editor. */
export const DEFAULT_LOCALE_SELECT_VALUE = '__default__'
